module.exports = __webpack_public_path__ + "img/img8.64a26783.svg";